"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperPropertyArrayItem = void 0;
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
/**
 * obiekt reprezentujący element tablciy
 *
 * @export
 * @class WrapperPropertyArrayItem
 * @implements {IWrapperPropertyArrayItem}
 */
var WrapperPropertyArrayItem = /** @class */ (function () {
    function WrapperPropertyArrayItem(dest, parent, key, schema, options) {
        this.$key = key;
        this._dest = dest;
        this._parent = parent;
        this._schema = schema;
        this._options = options;
        if (options.wrapAll || schema.type !== 'object') {
            this._cache = new WrappedPropertyCtor_1.default[this._schema.type](this._dest, this._parent, this.$key, this._schema, this._options);
            Object.seal(this._cache);
        }
        else {
            this._cache = null;
        }
    }
    Object.defineProperty(WrapperPropertyArrayItem.prototype, "$item", {
        /**
         * pobranie obiektu reprezentującego wartośc w tablicy
         *
         * @readonly
         * @type {IWrappedProperty}
         * @memberof WrapperPropertyArrayItem
         */
        get: function () {
            if (this._cache) {
                return this._cache;
            }
            else {
                var obj = new WrappedPropertyCtor_1.default[this._schema.type](this._dest, this._parent, this.$key, this._schema, this._options);
                Object.seal(obj);
                this._cache = obj;
                return obj;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * wyczyszczenie wewnętrznego cache zawierającego element tablicy
     *
     * @memberof WrapperPropertyArrayItem
     */
    WrapperPropertyArrayItem.prototype.$clearCache = function () {
        if (this._cache) {
            this._cache.$destroy();
            this._cache = undefined;
        }
    };
    /**
     * ustawienie $dirty na false ale tylko wtedy gdy jest pobrane
     *
     * @memberof WrapperPropertyArrayItem
     */
    WrapperPropertyArrayItem.prototype.$reset = function () {
        if (this._cache) {
            this._cache.$reset();
        }
    };
    /**
     * lista ellentów dotkęniętych przez użytkownika
     *
     * @param {any[]} result
     * @returns
     * @memberof WrapperPropertyArrayItem
     */
    WrapperPropertyArrayItem.prototype.$dirtyList = function (result) {
        if (this._cache) {
            this._cache.$dirtyList(result);
        }
        return result;
    };
    /**
     * czyszczenie obiektu
     *
     * @memberof WrapperPropertyArrayItem
     */
    WrapperPropertyArrayItem.prototype.$destroy = function () {
        this.$clearCache();
    };
    /**
     * ustawienie nowego indeksu w tablicy
     *
     * @param {number} newKey
     * @memberof WrapperPropertyArrayItem
     */
    WrapperPropertyArrayItem.prototype.$setKey = function (newKey) {
        this.$key = newKey;
        if (this._cache) {
            this._cache.$changeKey(newKey);
        }
    };
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrapperPropertyArrayItem.prototype.beforePathChange = function () {
        if (this._cache) {
            this._cache.beforePathChange();
        }
    };
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrapperPropertyArrayItem.prototype.afterPathChange = function () {
        if (this._cache) {
            this._cache.afterPathChange();
        }
    };
    Object.defineProperty(WrapperPropertyArrayItem.prototype, "$model", {
        get: function () {
            return this._parent[this.$key];
        },
        enumerable: false,
        configurable: true
    });
    WrapperPropertyArrayItem.prototype.$removeRow = function () {
        this._dest.$removeRow(this.$key);
    };
    WrapperPropertyArrayItem.prototype.$remove = function () {
        this._dest.$removeRow(this.$key);
    };
    WrapperPropertyArrayItem.prototype.$moveUp = function () {
        this._dest.$moveUp(this.$key);
    };
    WrapperPropertyArrayItem.prototype.$moveDown = function () {
        this._dest.$moveDown(this.$key);
    };
    WrapperPropertyArrayItem.prototype.$clearRow = function () {
        this._dest.$clearRow(this.$key);
    };
    WrapperPropertyArrayItem.prototype.$clear = function () {
        this._dest.$clearRow(this.$key);
    };
    return WrapperPropertyArrayItem;
}());
exports.WrapperPropertyArrayItem = WrapperPropertyArrayItem;
//# sourceMappingURL=WrappedPropertyArrayItem.js.map